import { tsParser } from "./parsers/typescript_parser";
import { jsonMarshmallowParser } from "./parsers/marshmallow";
import { jsonSerializableParser } from "./parsers/json_serializable";
import { kotlinMoshiParser } from "./parsers/autovalue_kotlin";
import { autoValueMoshiParser } from "./parsers/autovalue_moshi";
import { equatableParser } from "./parsers/equatable";
import { modelBrickhubParser } from "./parsers/model_brickhub";

export default {
  methods: {
    processJSON(
      class_name,
      json,
      parser = "autovalue_moshi",
      is_json = false,
      equatable = false,
      copyWith = false,
      style = "basic"
    ) {
      switch (
        parser //.replace(/(\r\n|\r|\n){2,}/g, '$1\n');
      ) {
        case "autovalue_moshi":
          return autoValueMoshiParser(class_name, json)["_o_classes"];
        case "json_serializable":
          return jsonSerializableParser(class_name, json)["_o_classes"];
        case "mashmallow":
          // eslint-disable-next-line no-case-declarations
          return jsonMarshmallowParser(class_name, json)["_o_classes"];
        case "moshi_kotlin":
          return kotlinMoshiParser(class_name, json)["_o_classes"];
        case "typescript":
          return tsParser(class_name, json)["_o_classes"];
        case "equatable":
          return equatableParser(class_name, json)["_o_classes"];
        case "model_brickhub":
          return modelBrickhubParser(
            class_name,
            json,
            is_json,
            equatable,
            copyWith,
            style
          )["_o_classes"];
        default:
          throw `${parser} Not Implemented.`;
      }
      // return build_classes(class_name, json);
    },
    copyText: (text) => {
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      const success = document.execCommand("copy");
      document.body.removeChild(el);
      return success;
    },
  },
};
